import React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import * as Common from 'common/components';

const SubcompaniesListHeader = ({ t = (key) => key, companyId, canAdd = false }) => {
  return (
    <Common.PageHeader title={t('subcompanies.title')}>
      {canAdd && (
        <div className="btn-group pull-right">
          <Link to={`/companies/${companyId}/subcompanies/add`} className="btn btn-info">
            {t('actions.add')}
          </Link>
        </div>
      )}
    </Common.PageHeader>
  );
};

export default translate()(SubcompaniesListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/components/SubcompaniesHeader.js